import { useState, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { useUserSetting } from '../../../../hooks/use-user-setting';
import { saveUserSetting } from '../../../../store/user/user.actions';
import { orders } from './constants';

export const groupItemsBySettingKey = 'v3.Orders:Drawer:GroupItemsBy';

export const useUserSettingGroupItemsBy = () => {
  const groupByFromSetting = useUserSetting(groupItemsBySettingKey);
  const initialSettingState = groupByFromSetting ? groupByFromSetting.toLowerCase() : orders;
  const [userSettingGroupItemsBy, setUserSettingGroupItemsBy] = useState(initialSettingState);
  const dispatch = useDispatch();

  const updateUserSettingGroupItemsBy = useCallback(
    (newGroupBy) => {
      setUserSettingGroupItemsBy(newGroupBy);
      dispatch(
        saveUserSetting({
          settingName: groupItemsBySettingKey,
          settingValue: newGroupBy.toLowerCase(),
          excludeV3prefix: true,
        }),
      );
    },
    [setUserSettingGroupItemsBy, dispatch],
  );

  return {
    userSettingGroupItemsBy,
    setUserSettingGroupItemsBy: updateUserSettingGroupItemsBy,
  };
};
